import { QuoteGetResponse } from '@lio/api-types';
import { Grid, Box, ThemeProvider } from '@mui/material';
import { IconButton } from '@components/iconButton';
import { drawerListItems } from '@pages/QuoteDetails/constants/drawerListItems';
import { useEffect, useMemo } from 'react';
import { TQuoteApiResponse } from '@models/quotes';
import { useQuote } from '@services/quotes';
import { useParams, useSearchParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { useLayoutStore } from '@store/LayoutStore';
import composeTheme from '@theme/theme';
import { arraysOverlap } from '@utils/arrays';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';

const MobileQuoteMenu = () => {
  const { secondaryMenuTab, setSecondaryMenuTab } = useLayoutStore(
    (state) => ({
      secondaryMenuTab: state.secondaryMenuTab,
      setSecondaryMenuTab: state.setSecondaryMenuTab,
    }),
    shallow,
  );

  const { quoteId } = useParams<'quoteId'>();
  invariant(quoteId);

  const [searchParams] = useSearchParams();
  const sidebarItem = searchParams.get('sidebarItem');

  const quoteData = useQuote(quoteId);
  const quote = quoteData.quote as TQuoteApiResponse;
  const drawerItems = useMemo(() => {
    return drawerListItems.filter((it) => (it.isShown ? it.isShown(quote) : true));
  }, [quote]);

  useEffect(() => {
    if (sidebarItem === 'messages') {
      setSecondaryMenuTab('Messages' as any); // this works...
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarItem]);

  return (
    <Box
      sx={{
        width: '100vw',
        backgroundColor: 'common.white',
        top: '100%',
        position: 'absolute',
        height: 'calc(100vh - 230px)',
      }}
    >
      {drawerItems.find((item) => item.name === secondaryMenuTab)?.content}
    </Box>
  );
};

export const MobileQuoteNavigation = (quote: QuoteGetResponse) => {
  const { setSecondaryMenuTab } = useLayoutStore();
  const roles = useStore((state) => state.roles, shallow);
  const drawerItems = useMemo(() => {
    return drawerListItems.filter((it) => (it.isShown ? it.isShown(quote) : true));
  }, [quote]);

  return (
    <ThemeProvider theme={composeTheme('light')}>
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
          }}
        >
          {drawerItems
            ?.filter((i) => arraysOverlap(i.roles, roles))
            .map((item) => (
              <IconButton
                key={item.name}
                onClick={() => item.name && setSecondaryMenuTab(item.name)}
                sx={{ color: 'common.white' }}
              >
                {item.icon}
              </IconButton>
            ))}
        </Grid>
      </Grid>
      <MobileQuoteMenu />
    </ThemeProvider>
  );
};
